import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';

import { dateOptionsCriteria, footfallTabCriteria, boundariesCriteria} from '../../../utilities/epic-helpers';

import {
  FETCH_INSIGHTS_REPEAT_VS_UNIQUE,
  FETCH_INSIGHTS_REPEAT_VS_UNIQUE_ERROR,
  SET_INSIGHTS_REPEAT_VS_UNIQUE
} from '../../constants';


const insightsRepeatVsUnique = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_INSIGHTS_REPEAT_VS_UNIQUE),
    switchMap(() =>
      ajax({
        url: `${state$.value.auth.server}/report/repeat-device?${
          footfallTabCriteria(state$)
        }${
          boundariesCriteria(state$)
        }${
          dateOptionsCriteria(state$, 'footfall')
        }&v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {
          return {
            type: SET_INSIGHTS_REPEAT_VS_UNIQUE,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_INSIGHTS_REPEAT_VS_UNIQUE_ERROR,
            error,
          })
        )
      )
    )
  );

export default insightsRepeatVsUnique;
